import {
	Card,
	CardLayoutType,
	ContentBlock,
	ContentLoader,
	FlexAlign,
	FlexGap,
	FlexJustify,
	StackHorizontal,
	StackVertical,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import { FormatLocaleDate } from '@ukpostbox/helpers';
import React, { useEffect } from 'react';
import { useUserPersonalDetails } from '@ukpostbox/client-data';
import { useForm, FormProvider } from '@ukpostbox/frontend-framework/lib/ReactHookForm';
import { SettingsActionType } from '../../Types/SettingsTypes';
import UserAction from '../../Components/Controls/UserAction';
import { useSite } from '../../../_Global/Providers/SiteInterfaceProvider';

type UserPersonalDetailsType = {
	name: string;
	clientId: number;
	clientIdNo: string;
	userActions: Array<SettingsActionType>;
	manualActions: Array<SettingsActionType>;
};

function PersonalDetails() {
	const { t } = useTranslation();
	const { currentLocale, updatePageMeta } = useSite();
	const formMethods = useForm();

	const {
		status,
		data,
		error,
	}: {
		status: any;
		data: any | UserPersonalDetailsType;
		error: any;
		isFetching: any;
	} = useUserPersonalDetails();

	useEffect(() => {
		updatePageMeta({
			title: t(`settings.sections.${'Personal Details'}`),
		});
	}, [currentLocale]);

	return (
		<>
			<StackHorizontal align={FlexAlign.Center} justify={FlexJustify.Between} extraClass='mb-md'>
				<h2 className='mb-0'>{t(`settings.sections.${'Personal Details'}`)}</h2>
			</StackHorizontal>

			<FormProvider {...formMethods}>
				<StackVertical gap={FlexGap.ExtraLarge}>
					<div>
						<Card header={{ title: t('labels.general') }} type={CardLayoutType.SlimHeader} emptyBody>
							{status === 'pending' ? (
								<ContentLoader childHeight='6em' childCount={4} />
							) : status === 'error' ? (
								<ContentBlock error title={error.name} content={error.message} />
							) : (
								<>
									{data.manualActions.map((item: SettingsActionType) => (
										<div className='user-action' key={`preferencesManualAction${item.label}`}>
											<div className='fade'>{item.label}</div>
											<div>
												{item.label === 'DOB' ? FormatLocaleDate(item.value) : item.value}
											</div>
										</div>
									))}
								</>
							)}
						</Card>
					</div>

					<div>
						<Card
							header={{ title: t('settings.sections.contactDetails') }}
							type={CardLayoutType.SlimHeader}
							emptyBody
						>
							{status === 'pending' ? (
								<ContentLoader childHeight='6em' childCount={4} />
							) : status === 'error' ? (
								<ContentBlock error title={error.name} content={error.message} />
							) : (
								<>
									{data.userActions.map((item: SettingsActionType) => (
										<UserAction {...item} key={`preferencesUserAction${item.label}`} />
									))}
								</>
							)}
						</Card>
					</div>
				</StackVertical>
			</FormProvider>
		</>
	);
}

export default PersonalDetails;
